import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/cohera-frontend/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/cohera-frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-dm-sans\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/cohera-frontend/app/globals.css");
